import _DTO from "./_DTO";
import DeviceAccessoryDTO from './DeviceAccessoryDTO';

export default class RedBoxDTO extends _DTO {

  constructor(device) {
    super();
    this.id = device.id;
    this.accessories = RedBoxDTO.getMappedOrDefault(device, 'accessories', [], data => (data || []).map(d => new DeviceAccessoryDTO(d)));
    this.auxiliaries = RedBoxDTO.getMappedOrDefault(device, 'auxiliaries', [], data => (data || []).map(d => new DeviceAccessoryDTO(d)));
    this.sensors = RedBoxDTO.getMappedOrDefault(device, 'sensors', [], data => (data || []).map(d => new DeviceAccessoryDTO(d)));
    this.spareParts = RedBoxDTO.getMappedOrDefault(device, 'spareParts', [], data => (data || []).map(d => new DeviceAccessoryDTO(d)));
    this.options = RedBoxDTO.getMappedOrDefault(device, 'options', [], data => (data || []).map(d => new DeviceAccessoryDTO(d)));
  }
}
